export { default } from "./ListHistorialVentasMes";
